import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  PRODUCT_REQUEST,
  PRODUCT_SUCCESS,
  PRODUCT_FAILED,
  PRODUCT_CREATE,
  PRODUCT_CREATE_SUCCESS,
  PRODUCT_CREATE_FAILED,
  PRODUCT_DELETE,
  PRODUCT_DELETE_SUCCESS,
  PRODUCT_DELETE_FAILED,
  PRODUCT_EDIT,
  PRODUCT_EDIT_SUCCESS,
  PRODUCT_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * Product Actions
 */

function* fetchProduct({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/Product/GetProduct`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: PRODUCT_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: PRODUCT_FAILED, payload: error.response });
    }
  }
}

function* createProduct(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/Product/CreateProduct`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editProduct(action) {
  try {
    const response = yield call(
      axios.put,
      `${API_URL}/Product/api/Product/UpdateProduct`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: PRODUCT_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteProduct(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/Product/RemoveProduct?ProductId=${encodeURIComponent(action.payload.ProductId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: PRODUCT_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: PRODUCT_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootProductList() {
  yield all([
    takeLatest(PRODUCT_REQUEST, fetchProduct),
    takeLatest(PRODUCT_CREATE, createProduct),
    takeLatest(PRODUCT_DELETE, deleteProduct),
    takeLatest(PRODUCT_EDIT, editProduct),
  ]);
}